<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { PhxJournalSlider, PhxTabPanel, PhxTabs } from '@phx-styleguides/iwc';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  featuredPages: {
    type: Array,
    default: () => [],
  },
  displayFilters: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();

const tabs = computed(() => {
  return [
    { id: 'all', label: t('Journal.tabs.all') },
    ...props.items.map((item) => {
      return {
        id: item.id,
        label: item.label,
      };
    }),
  ];
});

const currentTab = ref('all');

function getSliderData(id) {
  return props.items.find((item) => item.id === id);
}
</script>

<template>
  <phx-tabs
    v-if="displayFilters"
    :id="`${id}-tabs`"
    class="tabs-group tabs-group--horizontal journal__tabs tabs-group--with-indicator"
    layout="start"
    :show-indicator="true"
    :value="currentTab"
    @change="(newTab) => (currentTab = newTab)"
  >
    <phx-tab-panel v-for="tab in tabs" :id="tab.id" :key="tab.id" :label="tab.label">
      <div v-if="tab.id === 'all'" class="stack stack--spacing-8">
        <phx-journal-slider
          v-if="featuredPages.length"
          :id="`${id}-featured`"
          :featured="true"
          :slides="featuredPages"
        />
        <div v-else />
        <!-- Hack if we don't have featured items -->

        <phx-journal-slider v-for="item in items" :key="item.id" v-bind="getSliderData(item.id)" />
      </div>

      <phx-journal-slider v-else v-bind="getSliderData(tab.id)" :title="null" />
    </phx-tab-panel>
  </phx-tabs>

  <div v-else class="stack stack--spacing-8 center center--sizing-3xl">
    <phx-journal-slider :id="`${id}-featured`" :featured="true" :slides="featuredPages" />
    <phx-journal-slider v-for="item in items" :key="item.id" v-bind="getSliderData(item.id)" />
  </div>
</template>
